import { RouteInfo } from '../vertical-menu.metadata';
export function getAlldata6() {
//Sidebar menu Routes and data
 const PTROUTES: RouteInfo[] = [
    {
        path: '/Admin/PatientAdmin/DashboardPatient/dashboard', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
]; 

if (sessionStorage.getItem('patientFinancing') == 'true') {
    PTROUTES.push(
    {
        path: '/Admin/PatientAdmin/InvoicesPatient/Invoices', title: 'Patient Invoice', icon: 'fa fa-hospital-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    )
}

if (sessionStorage.getItem('claimFinancing') == 'true') {
    PTROUTES.push(
        {
            path: '/Admin/PatientAdmin/InvoicesPatient/ClaimInvoices', title: 'Claim Invoice', icon: 'fa fa-hospital-o', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
        },
    )
}
    
    



return PTROUTES
}